import { useTranslation } from "react-i18next";

import type { CarouselProgressProps } from "./carousel-progress.type";
import styles from "./carousel-progress.module.css";

export const CarouselProgress = ({
  currentIdx,
  total,
  acceptedCount,
  skippedCount,
  progressPct,
}: CarouselProgressProps) => {
  const { t } = useTranslation();

  return (
    <div className={styles.progress}>
      <div className={styles["progress-info"]}>
        <span className={styles["progress-count"]}>
          {t("payfac.pagePendenciesCarouselPendency")}{" "}
          <strong className={styles["count-value"]}>{Math.min(currentIdx, total)}</strong>
          <span className={styles["progress-total"]}>
            {" "}
            {t("payfac.pagePendenciesCarouselOf")} {total}
          </span>
        </span>
        <div className={styles["progress-stats"]}>
          <span className={styles["stat-item"]}>
            {t("payfac.pagePendenciesCarouselAccepted")}:{" "}
            <strong className={styles["stat-value"]}>{acceptedCount}</strong>
          </span>
          <span className={styles["stat-item"]}>
            {t("payfac.pagePendenciesCarouselSkipped")}:{" "}
            <strong className={styles["stat-value"]}>{skippedCount}</strong>
          </span>
        </div>
      </div>
      <div className={styles["progress-track"]}>
        <div
          className={styles["progress-fill"]}
          style={{ width: `${progressPct}%` }}
        />
      </div>
    </div>
  );
};
